export default __webpack_public_path__ + "static/media/diversity6.c3a85292.webp";